import { rem } from 'polished'
import clsx from 'clsx'
import type { ReactNode } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  grid-area: content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${rem(16)};
  padding: ${rem(20)};
`

const Action = styled.div`
  display: flex;
  justify-content: flex-end;
`

interface Props {
  className?: string
  primary: ReactNode
  action: ReactNode
}

function _SponsoredTileContent({ className, primary, action }: Props) {
  return <Container className={clsx(_SponsoredTileContent.name, className)}>
    {primary}
    <Action>{action}</Action>
  </Container>
}

export default _SponsoredTileContent
